<template>
    <v-card class="message elevation-0 pa-0" max-width="48rem">
        <v-card-text class="message">
            <v-row no-gutters>
                <v-col cols="12" class="mb-3 text-caption">
                    {{ $t('Successfully_registered_with_Google_Authenticator') }}
                </v-col>
                <v-col cols="12" class="text-caption">
                    {{
                        $t(
                            'When_you_read_the_QR_code_from_Google_Authenticator_on_your_device,_one-time_password_will_be_displayed.'
                        )
                    }}
                </v-col>
                <v-col cols="12" class="mb-3 text-caption">
                    {{
                        $t(
                            'After_the_QR_Code_has_been_successfully_read,_click_the_Read_Complete_button_on_this_screen.'
                        )
                    }}
                </v-col>
                <v-col cols="12">
                    <alert-warning>
                        {{ $t('QR_code_can_not_be_reissued.') }}
                        {{ $t('Please_be_sure_to_read_on_this_screen.') }}
                    </alert-warning>
                </v-col>
                <v-col cols="12" class="text-center">
                    <soft-device-qrcode :uid="uid" :secret="secret" :issuer="issuer" />
                </v-col>
                <v-col v-if="issuer" cols="12">
                    <b>{{ $t('Account_Name') }}: {{ issuer }}（{{ uid }}）</b>
                </v-col>
                <v-col v-else cols="12">
                    <b>{{ $t('Account_Name') }}: {{ uid }}</b>
                </v-col>
                <v-col cols="12">
                    <b>{{ $t('Key') }}: {{ secret }}</b>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <button-app-control ref="submit-btn" :label="$t('Read_complete')" @click="readComplete" />
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AlertWarning, ButtonAppControl, SoftDeviceQrcode } from '../../atoms';

@Component({
    name: 'CardQrcodeDescription',
    components: {
        AlertWarning,
        ButtonAppControl,
        SoftDeviceQrcode,
    },
})
export default class CardQrcodeDescription extends Vue {
    @Prop({ default: 'SIO' }) issuer: string;
    @Prop({ default: '' }) uid: string;
    @Prop({ default: '' }) secret: string;

    /**
     * methods
     */
    readComplete(): void {
        this.$emit('readComplete');
    }
}
</script>

<style lang="scss">
.message {
    word-break: break-all;
}
</style>
